import {BaseApi, BaseApiV2} from "@newview/infrastructure";
export abstract class NVSystemBaseApi extends BaseApiV2 {
    public get ProxyName(): any {
        return 'NVSystemBaseApi';
    }
  
}
